/** Vue Router dynamic segment for multi-tenant paths (must match router route definitions). */
export const TENANT_ROUTE_PARAM = "tenantPrefix";

export const getTenantPrefix = () => {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  return pathSegments.length > 0 ? pathSegments[0] : null;
};

export const getTenantPrefixFromRoute = (route) => {
  const fromParams = route?.params?.[TENANT_ROUTE_PARAM];
  if (fromParams != null && String(fromParams).trim() !== "") {
    return String(fromParams);
  }
  return getTenantPrefix();
};

export const resolveTenantIdFromBrowser = () => {
  const prefix = getTenantPrefix();
  if (prefix && prefix !== "login") return prefix;
  const last = localStorage.getItem("lastView");
  if (!last) return null;
  const pathOnly = String(last).split("?")[0] || "";
  const seg = pathOnly.split("/").filter(Boolean)[0];
  if (seg && seg !== "login") return seg;
  return null;
};

export const resolveTenantHeaderForApi = (explicitTenantId) => {
  if (explicitTenantId != null && explicitTenantId !== "") {
    return String(explicitTenantId);
  }
  const prefix = getTenantPrefix();
  return prefix && prefix !== "login" ? prefix : "";
};

/** Match a tenant row from URL, store hint, or localStorage (after tenants API load). */
export function pickTenantFromContext(tenants, hints = {}) {
  if (!Array.isArray(tenants) || tenants.length === 0) return null;

  const matchId = (id) => {
    if (id == null || String(id).trim() === "") return null;
    return tenants.find((t) => String(t.ID) === String(id)) || null;
  };

  const fromUrl = matchId(getTenantPrefix());
  if (fromUrl) return fromUrl;

  const fromHintId = matchId(hints.preferredId);
  if (fromHintId) return fromHintId;

  const preferredName = hints.preferredName || localStorage.getItem("tenantName");
  if (preferredName) {
    const fromName = tenants.find((t) => t.name === preferredName);
    if (fromName) return fromName;
  }

  return null;
}

export function hydrateSelectedTenantFromBrowser() {
  const id = resolveTenantIdFromBrowser();
  if (!id || id === "login") return null;
  let name = "";
  try {
    name = localStorage.getItem("tenantName") || "";
  } catch {
    void 0;
  }
  return { name, ID: id };
}
